export const drawstring_bag = {
  msrp: 19.99,
  infoLink: 'https://www.teamtriton.com/drawstring-bag.html',
  items: [
    {
      number: 'DB100',
      hasModel: false,
    },
    {
      number: 'DB101',
      hasModel: false,
    },
    {
      number: 'DB102',
      hasModel: false,
    },
    {
      number: 'DB103',
      hasModel: false,
    },
    {
      number: 'DB104',
      hasModel: false,
    },
    {
      number: 'DB105',
      hasModel: false,
    },
    {
      number: 'DB106',
      hasModel: false,
    },
    {
      number: 'DB107',
      hasModel: false,
    },
    {
      number: 'DB108',
      hasModel: false,
    },
    {
      number: 'DB109',
      hasModel: false,
    },
    {
      number: 'DB110',
      hasModel: false,
    },
    {
      number: 'DB111',
      hasModel: false,
    },
    {
      number: 'DB112',
      hasModel: false,
    },
    {
      number: 'DB113',
      hasModel: false,
    },
    {
      number: 'DB114',
      hasModel: false,
    },
    {
      number: 'DB115',
      hasModel: false,
    },
    {
      number: 'DB116',
      hasModel: false,
    },
    {
      number: 'DB117',
      hasModel: false,
    },
    {
      number: 'DB118',
      hasModel: false,
    },
    {
      number: 'DB119',
      hasModel: false,
    },
  ],
};
